import { useCallback, useEffect, useRef } from "react";

export const useIdleSession = ({ timeout, onExpire }) => {
  const timerId = useRef();

  const handleUserActivity = useCallback(() => {
    clearTimeout(timerId.current);
    timerId.current = setTimeout(onExpire, timeout);
  }, [onExpire, timeout]);

  useEffect(() => {
    const eventListeners = ["mousemove", "mousedown", "keydown", "touchstart"];

    eventListeners.forEach((event) => {
      document.addEventListener(event, handleUserActivity, { passive: true });
    });

    handleUserActivity();

    return () => {
      eventListeners.forEach((event) => {
        document.removeEventListener(event, handleUserActivity);
      });
      clearTimeout(timerId.current);
    };
  }, [handleUserActivity]);

  return { reset: handleUserActivity };
};
